import React from "react";
//#region types
import { ImportCustomerProps } from "models/propTypes/customerPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageLayouts, SimpleEntityTitle } from "components/common";
import CustomerImportFormContainer from "../forms/importFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ImportCustomer: React.FC<ImportCustomerProps> = ({ onFormSubmitSuccess }) => {
  return (
    <PageLayouts.EntityCreationLayout
      upperLeftComponent={
        <SimpleEntityTitle
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportCustomers)}
        />
      }
    >
      <CustomerImportFormContainer onFormSubmitSuccess={onFormSubmitSuccess} />
    </PageLayouts.EntityCreationLayout>
  );
};

export default ImportCustomer;
